import React from 'react';
import {Map} from 'immutable';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {stats, BUCKETS_ARRAY_INCREMENTING} from 'lib/StatsUtil';
import WordTooltip from 'sg/WordTooltip/WordTooltip.react';
import './mastery-level-breakdown.scss';

export default class MasteryLevelBreakdown extends React.Component {
  static propTypes = {
    masteryBuckets: PropTypes.instanceOf(Map),
    totalCount: PropTypes.number,
    tooltipPosition: PropTypes.string
  };

  makeMasteryBars(masteryBuckets) {
    return BUCKETS_ARRAY_INCREMENTING.map((bucket, i) => {
      return (
        <MasteryLevelBar
          key={i}
          itemCount={masteryBuckets.get(bucket.BUCKET_NAME)}
          totalCount={this.props.totalCount}
          label={bucket.DISPLAY_NAME}
        />
      );
    });
  }

  render() {
    const {masteryBuckets, totalCount, tooltipPosition} = this.props;

    return (
      <div className='mastery-level-breakdown'>
        <MasteryLevelTooltip tooltipPosition={tooltipPosition} />
        <ul className='mastery-level-breakdown__content'>
          <MasteryLevelBar
            itemCount={masteryBuckets.get('NOT_AVAILABLE')}
            totalCount={totalCount}
            label='N/A'
          />
          {this.makeMasteryBars(masteryBuckets)}
        </ul>
      </div>
    );
  }
}

class MasteryLevelTooltip extends React.Component {
  static propTypes = {
    tooltipPosition: PropTypes.string
  };

  render() {
    return (
      <div className='mastery-level-tooltip'>
        <WordTooltip
          position={this.props.tooltipPosition}
          term={
            <span>
              Mastery Levels <span className='fa fa-question-circle' />
            </span>
          }
          content={
            <ul className='mastery-level-tooltip__list'>
              {BUCKETS_ARRAY_INCREMENTING.map((bucket, i) => (
                <li className='mastery-level-tooltip__item' key={i}>
                  {bucket.DISPLAY_NAME}: {bucket.MIN}-{bucket.MAX}
                </li>
              ))}
            </ul>
          }
        />
      </div>
    );
  }
}

class MasteryLevelBar extends React.Component {
  static propTypes = {
    itemCount: PropTypes.number,
    totalCount: PropTypes.number,
    label: PropTypes.string
  };

  render() {
    const {itemCount, totalCount, label} = this.props;
    const percentage = stats.percentage(itemCount, totalCount) + '%';
    return (
      <li className='mastery-level-bar'>
        {percentage}
        <div className='mastery-level-bar__chart'>
          <div
            className={classnames(
              'mastery-level-bar__chart-fill',
              `mastery-level-bar__chart-fill--${label.replace(/[^\w]/, '').toLowerCase()}`
            )}
            style={{height: percentage}}
          />
        </div>
        {label}
      </li>
    );
  }
}
